import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const get_doctor_dashboard_data = createAsyncThunk(
  "dashboardIndex/get_doctor_dashboard_data",
  async (doctorId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/doctor/doctor-dashboard/${doctorId}`, {
        withCredentials: true,
      });

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_seller_dashboard_index_data = createAsyncThunk(
  "dashboardIndex/get_seller_dashboard_index_data",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/seller/get-dashboard-index-data`, {
        withCredentials: true,
      });

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_admin_dashboard_index_data = createAsyncThunk(
  "dashboardIndex/get_admin_dashboard_index_data",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/admin/get-dashboard-index-data`, {
        withCredentials: true,
      });

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const dashboardIndexReducer = createSlice({
  name: "dashboardIndex",
  initialState: {
    totalIncome: 0,
    totalAppt: 0,
    pendingAppt: 0,
    acceptedAppt: 0,
    doneAppt: 0,
    totalSale: 0,
    totalOrder: 0,
    sellerTotalOrder: 0,
    totalProduct: 0,
    totalPendingOrder: 0,
    totalSeller: 0,
    totalDoctor: 0,
    totalClient: 0,
    recentOrders: [],
    recentMessage: [],
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [get_doctor_dashboard_data.fulfilled]: (state, { payload }) => {
      state.totalIncome = payload.totalIncome;
      state.totalAppt = payload.totalAppt;
      state.pendingAppt = payload.pendingAppt;
      state.acceptedAppt = payload.acceptedAppt;
      state.doneAppt = payload.doneAppt;
    },
    [get_seller_dashboard_index_data.fulfilled]: (state, { payload }) => {
      state.totalSale = payload.totalSale;
      state.sellerTotalOrder = payload.sellerTotalOrder;
      state.totalProduct = payload.totalProduct;
      state.totalPendingOrder = payload.totalPendingOrder;
      state.recentOrders = payload.recentOrders;
      state.recentMessage = payload.messages;
      state.sellerMonthlyOrders = payload.sellerMonthlyOrders;
      state.sellerMonthlyRevenue = payload.sellerMonthlyRevenue;
      state.sellerMonthlyProducts = payload.sellerMonthlyProducts;
    },
    [get_admin_dashboard_index_data.fulfilled]: (state, { payload }) => {
      state.totalSale = payload.totalSale;
      state.totalOrder = payload.totalOrder;
      state.totalProduct = payload.totalProduct;
      state.totalSeller = payload.totalSeller;
      state.totalDoctor = payload.totalDoctor;
      state.totalClient = payload.totalClient;
      state.recentOrders = payload.recentOrders;
      state.recentMessage = payload.messages;
      state.monthlyOrders = payload.monthlyOrders;
      state.monthlyRevenue = payload.monthlyRevenue;
      state.monthlySellers = payload.monthlySellers;
    },
  },
});
export const { messageClear } = dashboardIndexReducer.actions;
export default dashboardIndexReducer.reducer;
